import script from "./CopyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyModal.vue?vue&type=script&setup=true&lang=js"

import "./CopyModal.vue?vue&type=style&index=0&id=4efd65fc&lang=css"

const __exports__ = script;

export default __exports__